import { useState, useEffect } from 'react';

interface NavbarProps {
  onGetFreeGuide: () => void;
}

export default function Navbar({ onGetFreeGuide }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'The Problem', href: '#problem' },
    { label: 'Products', href: '#products' },
    { label: 'Inside the Playbook', href: '#whats-inside' },
    { label: 'Testimonials', href: '#testimonials' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0a1628] shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        <a href="#hero" className="flex items-center gap-3">
          <img
            src="https://static.readdy.ai/image/08d571f8ebf239a419d6b3e9dcb7aa91/8ecda6c4b9269ddfaefdbd2a926c38bd.png"
            alt="The Recruiting Playbook"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </a>

        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="text-white/80 hover:text-[#f5a623] font-body text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="https://stan.store/The_RecruitingPlaybook/p/get-the-free-7step-playbook-now"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#f5a623] border border-[#f5a623] px-4 py-2 rounded-md font-body text-sm font-semibold hover:bg-[#f5a623]/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Free Guide
          </a>
          <a
            href="https://stan.store/The_RecruitingPlaybook/p/get-the-recruiting-playbook-now"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#f5a623] text-[#0a1628] px-5 py-2 rounded-md font-body text-sm font-bold hover:bg-[#f7b84b] transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Get the Playbook — $47
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-3-line text-2xl'} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-[#0a1628] border-t border-white/10 px-4 pb-6 pt-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-white/80 hover:text-[#f5a623] font-body text-base font-medium transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://stan.store/The_RecruitingPlaybook/p/get-the-free-7step-playbook-now"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMenuOpen(false)}
            className="text-[#f5a623] border border-[#f5a623] px-4 py-3 rounded-md font-body text-sm font-semibold whitespace-nowrap cursor-pointer text-center"
          >
            Get the Free Guide
          </a>
          <a
            href="https://stan.store/The_RecruitingPlaybook/p/get-the-recruiting-playbook-now"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMenuOpen(false)}
            className="bg-[#f5a623] text-[#0a1628] px-4 py-3 rounded-md font-body text-sm font-bold text-center whitespace-nowrap cursor-pointer"
          >
            Get the Playbook — $47
          </a>
        </div>
      )}
    </nav>
  );
}
